import UserService from '@/services/user-service';
import { useAuthStore } from '@/store/use-auth-store';
import {
  AuthMeCohort,
  AuthMeResponse,
  getAuthMeCohorts,
  resolveAuthMeScopeId,
} from './auth-me';

/** Persist primary cohort scope from /auth/me/ into the auth store. */
export function applyAuthMeScope(data: AuthMeResponse): {
  cohorts: AuthMeCohort[];
  scopeId: string | null;
} {
  const cohorts = getAuthMeCohorts(data);
  const scopeId = resolveAuthMeScopeId(data);

  useAuthStore.getState().setCurrentCohorts(cohorts);
  useAuthStore.getState().setOrgId(scopeId);

  return { cohorts, scopeId };
}

/** Refresh scope from /auth/me/ (e.g. after tenant switch). */
export async function syncAuthScopeFromCurrentUser(options?: {
  tenantId?: number;
}): Promise<{
  data: AuthMeResponse;
  cohorts: AuthMeCohort[];
  scopeId: string | null;
}> {
  const data = (await UserService.getCurrentUser({
    tenantId: options?.tenantId,
  })) as AuthMeResponse;
  const { cohorts, scopeId } = applyAuthMeScope(data);
  return { data, cohorts, scopeId };
}
